import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React from "react";
import bgImage from "assets/images/gdpr.png";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Gdpr = () => {
  const [t] = useTranslation("common");
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "left",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="left" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              <h2>{t("dataprotection.header")}</h2>
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h3>{t("dataprotection.registerholderheader")}</h3>
              {t("dataprotection.registerholdertext")}
              <h3>{t("dataprotection.registernameheader")}</h3>
              {t("dataprotection.registernametext")}
              <h3>{t("dataprotection.registerformheader")}</h3>
              {t("dataprotection.registerformtext")}
              <h3>{t("dataprotection.registerusageheader")}</h3>
              {t("dataprotection.registerusagetext")}
              <h3>{t("dataprotection.registercontainsheader")}</h3>
              {t("dataprotection.registercontainstext")}
              <h3>{t("dataprotection.registersourceheader")}</h3>
              {t("dataprotection.registersourcetext")}
              <h3>{t("dataprotection.registerinfotransferheader")}</h3>
              {t("dataprotection.registerinfotransfertext")}
              <h3>{t("dataprotection.savingtimesheader")}</h3>
              {t("dataprotection.savingtimestext")}
              <h3>{t("dataprotection.automateddecisionsheader")}</h3>
              {t("dataprotection.automateddecisionstext")}
              <h3>{t("dataprotection.protectionheader")}</h3>
              {t("dataprotection.protectiontext")}
              <h3>{t("dataprotection.rightofinspectionheader")}</h3>
              {t("dataprotection.rightofinspectiontext")}
              <h3>{t("dataprotection.rightoffixinfosheader")}</h3>
              {t("dataprotection.rightoffixinfostext")}
              <h3>{t("dataprotection.otherrightsforpersonalinfosheader")}</h3>
              {t("dataprotection.otherrightsforpersonalinfostext")}
              <h3>{t("dataprotection.rightofappealheader")}</h3>
              {t("dataprotection.rightofappealtext")}
              <br />
              <br />
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Gdpr;
